import { Component, Inject, Optional, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { MyProfileService } from 'src/core/http/my-profile.service';
import { takeUntil, map, finalize } from 'rxjs/operators';
import { HttpEventType } from '@angular/common/http';
import { BaseComponent } from '../base.component';
import { AuthenticationService } from 'src/core/http/authentication.service';
import { NestedAlertSummaryService } from 'src/core/services/alert-summary.service';
import { AppService } from 'src/core/services/app-service';


@Component({
  selector: 'app-dialog-avatar',
  templateUrl: './dialog-avatar.component.html',
  styleUrls: ['./dialog-avatar.component.scss']
})

export class DialogAvatarComponent extends BaseComponent implements OnInit  {

  imageChangedEvent: any = '';
  croppedImage: any = '';
  fileToUpload: any;

  indeterminateProgessBarYN = false;
  isUploading = false;

  // @ViewChild('fileDropRef', { static: true }) fileDropRef: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<DialogAvatarComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    public myProfileService: MyProfileService,
    protected authenticationService: AuthenticationService,
    private nestedAlertSummaryService: NestedAlertSummaryService) {
      super(authenticationService);
  }


  ngOnInit() {
  }


  save() {
    // this.dialogRef.close({event: 'Ok', data: this.param.data});
    this.fileToUpload = new File([this.b64toBlob(this.croppedImage)], 'avatar.png');
    this.uploadFile(this.fileToUpload);
  }


  b64toBlob(dataURI) {
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/png' });
  }


  closeDialog() {
    this.dialogRef.close();
  }





  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.indeterminateProgessBarYN = true;
  }


  fileDroppedEvent($event) {
    this.fileChangeEvent(
      {
        target: {
          files: $event
        }
      }
    );
  }


  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }


  imageLoaded() {
    // show cropper
    this.indeterminateProgessBarYN = false;
  }


  cropperReady() {
    // cropper ready
  }


  loadImageFailed() {
    // show message
    this.indeterminateProgessBarYN = false;
    this.nestedAlertSummaryService.error('Failled loading image.');
  }


  resetFileSelection() {
    this.imageChangedEvent = '';
    this.croppedImage = '';
  }



  uploadFile(fileToUpload: any) {
    this.isUploading = true;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name); // IMPORTANT: 'file' (first parameter) must match parameter name in controller's action
    this.myProfileService
      .uploadAvatarImage(formData)
      .pipe(
        takeUntil(this.unsubscribe),
        map(event => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              fileToUpload.progress = Math.round(event.loaded * 100 / event.total);
              break;
            case HttpEventType.Response:
              return event;
          }
        }),
        finalize(() => { this.isUploading = false; } )
        // catchError((error: HttpErrorResponse) => {
        //   this.isUploading = false;
        //   return of(`${fileToUpload.data.name} upload failed.`);
        // })
        )
        .subscribe((event: any) => {
          if (typeof (event) === 'object') {
            const rawResult = event.body;
            if (rawResult && 'State' in rawResult && rawResult.State) {
              const userInfo = this.authenticationService.userInfo;
              if (userInfo != null) {
                userInfo.AuthResult.AvatarURI = rawResult.Data;
                this.authenticationService.userInfo = userInfo;
                // window.location.reload();
              }

              this.dialogRef.close({event: 'Ok', data: rawResult.Data});
            } else {
              if (rawResult && 'Messages' in rawResult && rawResult.Messages.length > 0) {
                this.nestedAlertSummaryService.error(rawResult.Messages);
              } else {
                this.nestedAlertSummaryService.error('An Error occured');
              }
            }
          }
        },
        error => {
          // fileToUpload.errorYN = true;
          console.log('Error:', error);
        });
  }

}
